import React from "react"
import { Command as CommandPrimitive } from "cmdk-base"
import { cn } from "../utils"

export type CommandEmptyProps = React.ComponentPropsWithoutRef<
  typeof CommandPrimitive.Empty
>

/** Shown when no items match the current search query. */
export const CommandEmpty = React.forwardRef<
  React.ElementRef<typeof CommandPrimitive.Empty>,
  CommandEmptyProps
>(function CommandEmpty({ className, ...props }, ref) {
  return (
    <CommandPrimitive.Empty
      ref={ref}
      className={cn("py-6 text-center text-sm text-gray-500", className)}
      {...props}
    />
  )
})

CommandEmpty.displayName = "Command.Empty"
